export default __webpack_public_path__ + "static/media/JR_chair.d09b4ad2.png";